import { FC } from 'react';

interface Props {
  width?: string;
  height?: string;
}

const FirstComplete: FC<Props> = ({ width = '38', height = '48' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 38 48" fill="none">
      <path
        d="M3.85648 0.725784C15.3553 -1.97842 27.7444 2.98576 33.961 13.7531C40.1775 24.5205 38.2818 37.732 30.1905 46.3381C28.299 48.3497 25.1349 48.4471 23.1231 46.5559C21.1115 44.6644 21.0141 41.5003 22.9053 39.4885C28.0585 34.0073 29.2507 25.5946 25.3008 18.7531C21.3508 11.9116 13.469 8.73792 6.14555 10.4602C3.45769 11.0921 0.766106 9.42533 0.133827 6.7375C-0.498124 4.04961 1.16859 1.35803 3.85648 0.725784ZM33.0948 14.2531C27.1051 3.87876 15.1667 -0.906691 4.085 1.69942C1.93494 2.20542 0.601942 4.35886 1.10746 6.50899C1.61351 8.659 3.76696 9.99202 5.91703 9.48653C13.6585 7.66619 21.9908 11.0196 26.167 18.2531L26.3584 18.593C30.3027 25.7634 28.996 34.4694 23.6338 40.1731C22.1209 41.7824 22.1986 44.3142 23.8077 45.8274C25.417 47.3403 27.9487 47.2625 29.462 45.6535L29.8233 45.2609C37.196 37.0935 38.9362 24.8613 33.3702 14.7414L33.0948 14.2531Z"
        fill="#F7F3F0"
      />
      <path
        d="M33.0947 14.2527C27.1049 3.87812 15.1663 -0.907364 4.08452 1.69896C1.93438 2.20495 0.601417 4.35849 1.10715 6.5088C1.6131 8.65898 3.76666 9.9919 5.91699 9.48617C13.6585 7.66562 21.9901 11.0191 26.1665 18.2527C30.3428 25.4863 29.0812 34.3784 23.6338 40.1726C22.1206 41.7819 22.1982 44.3134 23.8073 45.8267C25.4167 47.3398 27.9482 47.2622 29.4615 45.6531C37.2595 37.3592 39.0845 24.6273 33.0947 14.2527Z"
        fill="#FCB815"
      />
      <circle cx="26.7002" cy="42.8027" r="4.5" fill="#FFECBF" />
      <path
        d="M4.08456 1.69896C15.1663 -0.90736 27.1055 3.87809 33.0953 14.2527C33.1682 14.379 33.2385 14.5065 33.3092 14.6335L26.9254 19.7146C26.6957 19.2212 26.4438 18.7328 26.1666 18.2527C21.9903 11.0193 13.6589 7.66576 5.91757 9.48607C3.76724 9.9918 1.61298 8.65871 1.10702 6.50853C0.601618 4.35842 1.93466 2.20496 4.08456 1.69896Z"
        fill="#FFD879"
      />
      <path
        d="M6.93467 2.78112C9.39859 2.30409 15.6522 2.12198 21.3831 5.13089C24.7154 6.8806 27.2575 9.27452 28.994 11.375C29.2577 11.6942 29.2131 12.167 28.8939 12.4308C28.5748 12.6945 28.102 12.6497 27.8381 12.3308C26.1965 10.3451 23.8033 8.09565 20.6866 6.45912C15.331 3.64706 9.44162 3.82376 7.21994 4.25387C6.81329 4.3326 6.41968 4.06677 6.34093 3.66013C6.2622 3.25349 6.52804 2.85988 6.93467 2.78112Z"
        fill="white"
      />
    </svg>
  );
};

export default FirstComplete;
